<template>
  <div>
    <el-drawer @reload="$reloadHandle"
               :title="'图片质检'" size="30%"
               :before-close="handleClose"
               :visible.sync="visiable"
               direction="rtl"
               :modal-append-to-body="true"
               custom-class="demo-drawer"
               ref="drawer"
    >

      <div class="demo-drawer__content">
        <el-form :model="formData" >
          <el-form-item label="分配质检人" :rules="{required: true}">
            <el-input v-model="formData.qualityMan" size="small" style="width:9vw!important ;" clearable>
              <i slot="suffix" class="el-input__icon el-icon-search"
                 @click="showDialog = true"></i>
            </el-input>
          </el-form-item>
        </el-form>

        <div class="demo-drawer__footer" style="position: absolute;
    bottom: 5px;
    right: 5px;">
          <el-button @click="cancelForm">取 消</el-button>
          <el-button type="primary" @click="close">
            确 定
          </el-button>
        </div>
      </div>
    </el-drawer>

    <userDialog v-if="showDialog"
              @commitAdminRow="commitAdminRow"
              :visiable.sync="showDialog"
              :title="'质检分配用户选择'"
              multi="true"/>
  </div>
</template>
<script>
import api from "@/api/projectApi";
import DictSelect from "@/components/formItem/dictSelect.vue";
import userDialog from "@/views/dialogCommon/adminDialog.vue";

export default {
  name: 'picAssignDialog',
  components: {userDialog, DictSelect},
  props: ['visiable', 'multi', 'param'],
  created() {
    if (this.param) {
      this.$objCopy(this.param, this.formData)
    }
  },
  data() {
    return {
      showDialog: false,
      formData: {
        qualityMan: null,
        dictId: null,
        dictName: null,
        idList: null,
        type: null
      },
      drawer: true,
    }
  },
  methods: {
    // 关闭
    close() {
      if (!this.formData.qualityMan) {
        this.$message.error('请选择质检人')
        return
      }

      this.$mask.open()
      this.$http({
        url: api.picCheck.allocationUrl,
        method: 'post',
        data: this.formData
      }).then(res => {
        this.$mask.close()
        this.$message.success('操作成功')
        this.cancelForm()
        this.$emit('goBackIndex')
      }).catch(() => {
        this.$mask.close()
      })
    },

    //确定选择质检人
    commitAdminRow(data) {
      this.formData.qualityMan = data.username
    },


    confirm() {
      this.drawer = false;
      this.handleClose()
    },
    cancelForm() {
      this.visiable = false
      this.$emit('update:visiable', this.visiable)
    },
    handleClose() {
      this.cancelForm()
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-drawer .el-drawer__body {
  padding: 0 16px;
  background-color: #fff;
  position: relative;
}

::v-deep .el-drawer .el-drawer__header {
  background-color: #fff;
}

::v-deep .el-drawer__container {
  position: relative;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  height: 100%;
  width: 100%;
  background: aliceblue;
  background-color: rgb(38 38 38 / 70%);
}

#containt .table-detail {
  border-collapse: collapse;
  font-size: 12px;
  border: 1px solid #ededed;
}

.btn {
  text-align: center;
}
</style>
